import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSummaryViewMode } from '../../../../selectors/elementsVisibility';
import { selectIsMobileLayout } from '../../../../selectors/layout';
import { EElementsVisibilitySummaryView } from '../../../../types/reducers/elementsVisibility';
import { Layout } from '../../../ServicePickerWidget/Layout';

export interface ISummaryLayoutProps {
  title: React.ReactNode;
  content: React.ReactNode;
}

export const SummaryLayout = ({ content, title }: ISummaryLayoutProps) => {
  const summaryViewMode = useSelector(selectSummaryViewMode);
  const isMobile = useSelector(selectIsMobileLayout);

  const showMultilineTotal = summaryViewMode === EElementsVisibilitySummaryView.Multiline;

  const showTitle = !showMultilineTotal && !isMobile;

  return (
    <div data-name="Summary" data-testid="summary">
      <Layout>
        {showTitle && <Layout.Title>{title}</Layout.Title>}
        <Layout.Content>{content}</Layout.Content>
      </Layout>
    </div>
  );
};
